import { render, staticRenderFns } from "./testComponent.vue?vue&type=template&id=832f09c0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./testComponent.vue?vue&type=script&lang=js&"
export * from "./testComponent.vue?vue&type=script&lang=js&"
import style0 from "./testComponent.vue?vue&type=style&index=0&id=832f09c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832f09c0",
  null
  
)

component.options.__file = "testComponent.vue"
export default component.exports